import { render } from "./CropperPage.vue?vue&type=template&id=bf6a14ec"
import script from "./CropperPage.vue?vue&type=script&lang=js"
export * from "./CropperPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__